/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import React from 'react';
import { BlocDemandesDemat } from '@mairistem/administres-utils';
import { Dimmer } from '@mairistem/composants';

import { useResizer } from '@/hooks';
import HubeeStatusMessage from '@/components/Hubee/HubeeStatusMessage';
import {
  useEntiteStore,
  useHubeeStore,
  useProduitDomaineStore,
} from '@/zustand';

import {
  BlocCreation,
  BlocInsee,
  BlocListe,
  BlocStatistiques,
  BlocSynthetique,
} from './Blocs';

const URL_LISTE_HUBEE = _.includes(window.location.href, '360.')
  ? '/administres/pacs/hubee'
  : '/hubee';

/**
 * Demandes dématérialisées HubEE, géré comme dans RCO : les compteurs ne sont
 * chargés que si l'entité est abonnée et la liaison active, sinon le message
 * de statut HubEE recouvre le bloc.
 */
const BlocHubee = () => {
  const produitDomaine = useProduitDomaineStore(
    (state) => state.produitDomaine,
  );
  const entite = useEntiteStore((state) => state.selectedEntite);
  const hubeeStatus = useHubeeStore((state) => state.hubeeStatus);

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <BlocDemandesDemat
        route="/api/administres/etat-civil/hubee"
        urlListe={URL_LISTE_HUBEE}
        dataLoaded={
          !_.isNil(produitDomaine) &&
          !_.isNil(entite) &&
          !_.isNil(hubeeStatus) &&
          hubeeStatus.serialized &&
          hubeeStatus.liaisonActive
        }
      />
      {!_.isNil(hubeeStatus) &&
        (!hubeeStatus.serialized || !hubeeStatus.liaisonActive) && (
          <Dimmer active inverted style={{ borderRadius: 16 }}>
            <div style={{ textAlign: 'center' }}>
              <HubeeStatusMessage
                serialized={hubeeStatus.serialized}
                liaisonActive={hubeeStatus.liaisonActive}
              />
            </div>
          </Dimmer>
        )}
    </div>
  );
};

const Dashboard = () => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [, setLoadingSynthetique] = React.useState<boolean>(false);
  const [, setLoadingInsee] = React.useState<boolean>(false);
  useResizer(width, setWidth);

  const renderMobileScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          overflowY: 'auto',
          padding: '1em',
          gap: '1em',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <BlocCreation />
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1em',
            height: 200,
          }}
        >
          <BlocInsee
            setLoading={setLoadingInsee}
            style={{ width: 300, margin: 0, height: '100%' }}
          />
          <div style={{ flex: 1 }}>
            <BlocHubee />
          </div>
        </div>
        <BlocSynthetique setLoading={setLoadingSynthetique} />
        <BlocStatistiques />
        <BlocListe />
      </div>
    ),
    [],
  );

  const renderDesktopScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          display: 'flex',
          gap: '1em',
          padding: '1em',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            flex: 6,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          <BlocCreation style={{ margin: 0, minHeight: 200, maxHeight: 200 }} />
          <BlocListe style={{ margin: 0, flex: 1 }} />
        </div>
        <div
          style={{
            flex: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          <BlocSynthetique
            style={{ margin: 0, height: 200 }}
            setLoading={setLoadingSynthetique}
          />
          <BlocStatistiques style={{ margin: 0, flex: 1 }} />
          <div
            style={{
              height: 200,
              display: 'flex',
              flexDirection: 'row',
              gap: '1em',
            }}
          >
            <BlocInsee
              setLoading={setLoadingInsee}
              style={{ width: 300, margin: 0, height: '100%' }}
            />
            <div style={{ flex: 1 }}>
              <BlocHubee />
            </div>
          </div>
        </div>
      </div>
    ),
    [],
  );
  if (width < 1200) return renderMobileScreen;

  return renderDesktopScreen;
};

export default Dashboard;
